<script>
    import R, {LOADER} from "../../lib/requests";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';

    export let right = false;
    export let small = false;

    let list = null;
    let code = '';
    let listIndex = -1;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onCodeChange = (event) => {
        if (code) {
            load();
        }
    }

    const onKeyUp = (event) => {
        // if (event.key === 'Enter' && code) {
        //     load();
        // }
    }

    const onKeyDown = (event) => {
        if (list && list.length) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (listIndex >= list.length) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (listIndex < 0) {
                    listIndex = list.length - 1;
                }
            } else if (event.key === 'Enter') {
                if (listIndex > -1) {
                    onSelect(list[listIndex]);
                } else {
                    closeDropdown();
                }
            } else if (event.key === 'Escape') {
                closeDropdown();
            }
        } else {
            if (event.key === 'Enter' && code) {
                load();
            }
        }
    }

    const onSelect = (item) => {
        closeDropdown();
        code = '';
        dispatch("select", item);
    }

    const closeDropdown = () => {
        list = null;
        listIndex = -1;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const load = () => {
        const onSuccess = result => {
            list = result;
            if (list.length) {
                document.addEventListener('keydown', handleEscapeKey);
            }
        }

        const onFailure = err => {
        };

        let data = {
            term: code
        }

        R.handle(R.analyses.index, data, onSuccess, onFailure, LOADER.POPUP);
    }
</script>

<div class="analysis-select dropdown-container" use:clickOutside on:click_outside="{ closeDropdown }">
    <input type="text" class="form-control" class:form-control-sm={ small } bind:value="{ code }"
           on:change={ onCodeChange } on:keyup={ onKeyUp } on:keydown={ onKeyDown }
           placeholder="κωδικός, παράμετρος ή υλικό">
    {#if list != null}
        <div class="dropdown" class:right={ right }>
            {#each list as item, index}
                <li class="dropdown-item d-flex align-items-center"  class:selected="{ listIndex === index }" on:click={ () => onSelect(item) }>
                    <div class="code text-gray">{ item.code }</div>
                    <div class="parameter">{ item.name_el }</div>
                    <div class="material text-gray">{ item.material }</div>
                </li>
            {/each}
        </div>
    {/if}
</div>

<style>
    .analysis-select .form-control-sm {
        height: 32px;
    }
    .analysis-select .dropdown .dropdown-item {
        cursor: pointer;
    }

    .analysis-select .dropdown .dropdown-item .code {
        width: 40px;
    }

    .analysis-select .dropdown .dropdown-item .parameter {
        width: calc(100% - 70px - 200px);
    }

    .analysis-select .dropdown .dropdown-item .material {
        width: 200px;
        text-align: right;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>